import request from '@/utils/request';

// 新增方案
export function addScheme(query: object) {
    return request({
      url: '/schematic/design/add',
      method: 'post',
      data: query,
    });
}
// 编辑方案
export function updateScheme(query: object) {
    return request({
      url: '/schematic/design/edit',
      method: 'post',
      data: query,
    });
}
// 删除方案
export function deleteScheme(schemId: string|number) {
    return request({
      url: '/schematic/design/deleteDesign/' + schemId,
      method: 'delete',
    });
}
// 获取项目列表
export function getProject(query) {
    return request({
      url: '/proj/info/list',
      method: 'post',
      data: query,
    });
}
// 获取方案
export function getScheme(query: object) {
    return request({
        url: '/schematic/design/list',
        method: 'post',
        data: query,
    });
}
// 获取方案设计列表
export function getSchemeList(query) {
    return request({
        url: '/schematic/designC/list',
        method: 'post',
        data: query,
    });
}

// 获取设备类型
export function getDeviceType(query) {
  return request({
      url: '/source/currType/list',
      method: 'post',
      data: query,
  });
}
// 获取设备名称
export function getDeviceName(query) {
  return request({
      url: '/resource/bill/names',
      method: 'post',
      data: query,
  });
}
// 获取规格型号
export function getModel(query) {
  return request({
      url: '/resource/bill/models',
      method: 'post',
      data: query,
  });
}
// 上传每年的发电量
export function uploadEnergy(query) {
  return request({
      url: '/schematic/design/import',
      method: 'post',
      headers: {'Content-Type':'multipart/form-data'},
      data: query,
  });
}